module.exports = getNonSellableBalance

const { NON_SELLABLE_ZONES } = require('./shipsy/constants')

// Sibling of getLedgerBalance for the non-sellable side. Sums signed deltas
// from avocado.stock_transactions where a non-sellable zone appears as either
// side of the movement, and returns per-SKU totals plus a per-zone breakdown.
//
// Sellable balances still live in the couch ledger — this function is only for
// the zones (DAMAGED, EXPIRY, RESERVED, etc.) that Shipsy manages outside the
// stock-count flow.
async function getNonSellableBalance ({ pgConnection, locationId, date }) {
  if (!pgConnection) {
    throw new Error('getNonSellableBalance: pgConnection is required')
  }
  if (!locationId) {
    throw new Error('getNonSellableBalance: locationId is required')
  }

  const values = [locationId, NON_SELLABLE_ZONES]
  let text = `
    SELECT sku, origin, origin_zone, destination, destination_zone, quantity
    FROM avocado.stock_transactions
    WHERE (
      (origin = $1 AND origin_zone = ANY($2))
      OR (destination = $1 AND destination_zone = ANY($2))
    )
  `

  if (date) {
    values.push(date)
    text += ` AND created_at <= $${values.length}`
  }

  const { rows } = await pgConnection.query(text, values)

  const nonSellable = new Set(NON_SELLABLE_ZONES)
  const bySku = {}

  const apply = (sku, zone, qty) => {
    const productKey = `product:${sku}`
    let bucket = bySku[productKey]
    if (!bucket) {
      bucket = { total: 0, zones: {} }
      bySku[productKey] = bucket
    }
    bucket.zones[zone] = (bucket.zones[zone] || 0) + qty
    bucket.total += qty
  }

  for (const row of rows) {
    const qty = Number(row.quantity)

    // A single row can affect two non-sellable zones (e.g. a zone_movement
    // between DAMAGED and EXPIRY), so credit destination and debit origin
    // independently rather than as an either/or.
    if (row.destination === locationId && nonSellable.has(row.destination_zone)) {
      apply(row.sku, row.destination_zone, qty)
    }
    if (row.origin === locationId && nonSellable.has(row.origin_zone)) {
      apply(row.sku, row.origin_zone, -qty)
    }
  }

  return bySku
}
